export function setSearchHeader()
{
	if (window.location.href.indexOf(siteSearchPage + "?result") !== -1)
	{
		const list = [false];
		if ($("select[name=husdyr] option:selected").val() === '3')
		{
			list[0] = true;
		}

		$('.searchSectionItem').each(function (i, el)
		{
			if (list[i] === true)
			{
				$(el).removeClass('hidden');
			}
			else
			{
				if (!$(el).hasClass('hidden'))
				{
					$(el).addClass('hidden');
				}
			}
		});
	}
}
